//
// 給与・賞与明細 一覧／個別表示（F-PAY-02 / F-PAY-04）
//
// 一覧は支給日の前日以降のものだけが返る。個別明細はメールで届く
// ワンタイムリンク（15分有効）のトークン付きで開く。
//
var utils = require('../../utils')

export default {
  name: 'payroll-list',
  created () {
    if (this.isPayrollExcluded) {
      this.$router.push({ path: '/' })
      return
    }
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      sendingId: null,
      downloading: false
    }
  },
  computed: {
    documents () {
      return this.$store.getters.payrollDocuments || []
    },
    document () {
      return this.$store.getters.payrollDocument
    },
    message () {
      return this.$store.getters.payrollMessage
    },
    error () {
      return this.$store.getters.payrollError
    },
    isPayrollExcluded () {
      return window.localStorage.getItem('is_payroll_excluded') === '1'
    }
  },
  methods: {
    search: function () {
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        // メールのリンク（/#/payroll/documents/:id?token=）から開かれた場合は明細を表示する
        if (self.$route.params.id && self.$route.query.token) {
          self.showDocument(self.$route.params.id, self.$route.query.token)
        }
      }
      this.$store.dispatch('GET_PAYROLL_DOCUMENTS', {callback: callback})
    },
    requestLink: function (id) {
      if (this.sendingId) {
        return
      }
      var self = this
      this.sendingId = id
      this.$store.dispatch('REQUEST_PAYROLL_LINK', {id: id})
      .then(() => { self.sendingId = null })
      .catch(() => { self.sendingId = null })
    },
    showDocument: function (id, token) {
      this.$store.dispatch('GET_PAYROLL_DOCUMENT', {id: id, token: token})
    },
    // 明細PDFをダウンロードする（署名URLは5分・ワンタイム）
    downloadPdf: function () {
      if (!this.document || this.downloading) {
        return
      }
      var self = this
      this.downloading = true
      var callback = function (data) {
        self.downloading = false
        if (data && data.url) {
          window.location.href = data.url
        }
      }
      this.$store.dispatch('GET_PAYROLL_DOWNLOAD_URL', {
        id: this.document.id,
        token: this.$route.query.token,
        callback: callback
      })
      .then(() => { self.downloading = false })
      .catch(() => { self.downloading = false })
    },
    goTop: function () {
      this.$router.push({ path: '/' })
    },
    // 金額として表示してよい列か（API の numeric に従う。未定義なら安全側でカンマ区切りしない）
    isAmountRow: function (row) {
      return !!(row && row.numeric)
    },
    // 金額列のみ3桁カンマ区切り。社員番号・氏名・支給日などはそのまま
    formatValue: function (row) {
      if (!row) {
        return ''
      }
      return this.isAmountRow(row) ? utils.formatAmount(row.value) : row.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/payroll-list.js